<p class="title" [class.rtl]="!isEnglish" [class.ltr]="isEnglish">{{ 'menu.dashboard' | translate }}</p>
<!-- cards -->
<app-dashboard-cards></app-dashboard-cards>
<!-- chars -->

<app-dasahboard-charts></app-dasahboard-charts>

<!-- footer -->
<app-dashboard-footer></app-dashboard-footer>
